/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { MembershipDTO } from "../model";
import { MembershipDTOTrackedI, MembershipDTOMeta } from "../model";
// @ts-ignore
import type { PersonDashboardDTO } from "../model";
import { PersonDashboardDTOTrackedI, PersonDashboardDTOMeta } from "../model";
// @ts-ignore
import type { PersonSearchCriteria } from "../model";
import {
  PersonSearchCriteriaTrackedI,
  PersonSearchCriteriaMeta,
} from "../model";
// @ts-ignore
import type { PersonWithRelationsDTO } from "../model";
import {
  PersonWithRelationsDTOTrackedI,
  PersonWithRelationsDTOMeta,
} from "../model";
// @ts-ignore
import type { PurchasableState } from "../model";
import { PurchasableStateTrackedI, PurchasableStateMeta } from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * PersonNewApi - axios parameter creator
 * @export
 */
export const PersonNewApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Gets a list of memberships
     * @param {number} [personId] The owner of the membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberMembershipsGet: (
      personId?: number,
      page?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/memberships`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }
      if (personId !== undefined) {
        localVarQueryParameter["personId"] = personId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets a list of memberships
     * @param {number} [personId] The owner of the membership
     * @param {PurchasableState} [purchasableState] The purchasable state of the membership (default ACTIVE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffMembershipsGet: (
      personId?: number,
      purchasableState?: PurchasableState,
      page?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/memberships`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }
      if (personId !== undefined) {
        localVarQueryParameter["personId"] = personId;
      }

      if (purchasableState !== undefined) {
        localVarQueryParameter["purchasableState"] = purchasableState;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Test new person dto
     * @param {PersonSearchCriteria} personSearchCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewDashboardPost: (
      personSearchCriteria: PersonSearchCriteria,
      page?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personSearchCriteria' is not null or undefined
      assertParamExists(
        "staffPersonsNewDashboardPost",
        "personSearchCriteria",
        personSearchCriteria,
      );
      const localVarPath = `/staff/personsNew/dashboard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        personSearchCriteria,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Test new person dto
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewIdGet: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("staffPersonsNewIdGet", "id", id);
      const localVarPath = `/staff/personsNew/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates person
     * @param {PersonWithRelationsDTO} personWithRelationsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewPost: (
      personWithRelationsDTO: PersonWithRelationsDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personWithRelationsDTO' is not null or undefined
      assertParamExists(
        "staffPersonsNewPost",
        "personWithRelationsDTO",
        personWithRelationsDTO,
      );
      const localVarPath = `/staff/personsNew`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        personWithRelationsDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Test new person dto
     * @param {PersonSearchCriteria} personSearchCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewSearchPost: (
      personSearchCriteria: PersonSearchCriteria,
      page?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personSearchCriteria' is not null or undefined
      assertParamExists(
        "staffPersonsNewSearchPost",
        "personSearchCriteria",
        personSearchCriteria,
      );
      const localVarPath = `/staff/personsNew/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        personSearchCriteria,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type memberMembershipsGetParams = {
  personId?: number;
  page?: number;
  pageSize?: number;
};
export type staffMembershipsGetParams = {
  personId?: number;
  purchasableState?: PurchasableState;
  page?: number;
  pageSize?: number;
};
export type staffPersonsNewDashboardPostParams = {
  personSearchCriteria: PersonSearchCriteria;
  page?: number;
  pageSize?: number;
};
export type staffPersonsNewIdGetParams = { id: number };
export type staffPersonsNewPostParams = {
  personWithRelationsDTO: PersonWithRelationsDTOTrackedI;
};
export type staffPersonsNewSearchPostParams = {
  personSearchCriteria: PersonSearchCriteria;
  page?: number;
  pageSize?: number;
};

export const memberMembershipsGetMeta = {
  personId: propertyMeta("personId", false, false, false, MetaTypesBase.number),
  page: propertyMeta("page", false, true, false, MetaTypesBase.number),
  pageSize: propertyMeta("pageSize", false, true, false, MetaTypesBase.number),
};
export const staffMembershipsGetMeta = {
  personId: propertyMeta("personId", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  page: propertyMeta("page", false, true, false, MetaTypesBase.number),
  pageSize: propertyMeta("pageSize", false, true, false, MetaTypesBase.number),
};
export const staffPersonsNewDashboardPostMeta = {
  personSearchCriteria: propertyMeta(
    "personSearchCriteria",
    false,
    true,
    false,
    PersonSearchCriteriaMeta,
  ),
  page: propertyMeta("page", false, true, false, MetaTypesBase.number),
  pageSize: propertyMeta("pageSize", false, true, false, MetaTypesBase.number),
};
export const staffPersonsNewIdGetMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const staffPersonsNewPostMeta = {
  personWithRelationsDTO: propertyMeta(
    "personWithRelationsDTO",
    false,
    true,
    false,
    PersonWithRelationsDTOMeta,
  ),
};
export const staffPersonsNewSearchPostMeta = {
  personSearchCriteria: propertyMeta(
    "personSearchCriteria",
    false,
    true,
    false,
    PersonSearchCriteriaMeta,
  ),
  page: propertyMeta("page", false, true, false, MetaTypesBase.number),
  pageSize: propertyMeta("pageSize", false, true, false, MetaTypesBase.number),
};

/**
 * PersonNewApi - functional programming interface
 * @export
 */
export const usePersonNewApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    PersonNewApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     *
     * @summary Gets a list of memberships
     * @param {number} [personId] The owner of the membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberMembershipsGetRaw(
      props: memberMembershipsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<MembershipDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberMembershipsGet(
        props.personId,
        props.page,
        props.pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.memberMembershipsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<MembershipDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<MembershipDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     *
     * @summary Gets a list of memberships
     * @param {number} [personId] The owner of the membership
     * @param {PurchasableState} [purchasableState] The purchasable state of the membership (default ACTIVE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffMembershipsGetRaw(
      props: staffMembershipsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<MembershipDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffMembershipsGet(
        props.personId,
        props.purchasableState,
        props.page,
        props.pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffMembershipsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<MembershipDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<MembershipDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Test new person dto
     * @param {PersonSearchCriteria} personSearchCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewDashboardPostRaw(
      props: staffPersonsNewDashboardPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<PersonDashboardDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPersonsNewDashboardPost(
          props.personSearchCriteria,
          props.page,
          props.pageSize,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewDashboardPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<PersonDashboardDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PersonDashboardDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Test new person dto
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewIdGetRaw(
      props: staffPersonsNewIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonWithRelationsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPersonsNewIdGet(
        props.id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonWithRelationsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonWithRelationsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates person
     * @param {PersonWithRelationsDTO} personWithRelationsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewPostRaw(
      props: staffPersonsNewPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonWithRelationsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPersonsNewPost(
        props.personWithRelationsDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonWithRelationsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonWithRelationsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Test new person dto
     * @param {PersonSearchCriteria} personSearchCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewSearchPostRaw(
      props: staffPersonsNewSearchPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<PersonWithRelationsDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPersonsNewSearchPost(
          props.personSearchCriteria,
          props.page,
          props.pageSize,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewSearchPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<PersonWithRelationsDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PersonWithRelationsDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     *
     * @summary Gets a list of memberships
     * @param {number} [personId] The owner of the membership
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberMembershipsGet(
      personId?: number,
      page?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<MembershipDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberMembershipsGet(
        personId,
        page,
        pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.memberMembershipsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<MembershipDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<MembershipDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     *
     * @summary Gets a list of memberships
     * @param {number} [personId] The owner of the membership
     * @param {PurchasableState} [purchasableState] The purchasable state of the membership (default ACTIVE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffMembershipsGet(
      personId?: number,
      purchasableState?: PurchasableState,
      page?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<MembershipDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffMembershipsGet(
        personId,
        purchasableState,
        page,
        pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffMembershipsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<MembershipDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<MembershipDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Test new person dto
     * @param {PersonSearchCriteria} personSearchCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewDashboardPost(
      personSearchCriteria: PersonSearchCriteria,
      page?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<PersonDashboardDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPersonsNewDashboardPost(
          personSearchCriteria,
          page,
          pageSize,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewDashboardPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<PersonDashboardDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PersonDashboardDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Test new person dto
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewIdGet(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonWithRelationsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPersonsNewIdGet(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonWithRelationsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonWithRelationsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updates person
     * @param {PersonWithRelationsDTO} personWithRelationsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewPost(
      personWithRelationsDTO: PersonWithRelationsDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonWithRelationsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPersonsNewPost(
        personWithRelationsDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonWithRelationsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonWithRelationsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Test new person dto
     * @param {PersonSearchCriteria} personSearchCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPersonsNewSearchPost(
      personSearchCriteria: PersonSearchCriteria,
      page?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<PersonWithRelationsDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPersonsNewSearchPost(
          personSearchCriteria,
          page,
          pageSize,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonNewApi.staffPersonsNewSearchPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<PersonWithRelationsDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PersonWithRelationsDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * PersonNewApi - interface
 * @export
 * @interface PersonNewApi
 */
export interface PersonNewApiInterface {
  /**
   *
   * @summary Gets a list of memberships
   * @param {number} [personId] The owner of the membership
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonNewApiInterface
   */
  memberMembershipsGet(
    personId?: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<MembershipDTO>>;

  /**
   *
   * @summary Gets a list of memberships
   * @param {number} [personId] The owner of the membership
   * @param {PurchasableState} [purchasableState] The purchasable state of the membership (default ACTIVE)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonNewApiInterface
   */
  staffMembershipsGet(
    personId?: number,
    purchasableState?: PurchasableState,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<MembershipDTO>>;

  /**
   * Test new person dto
   * @param {PersonSearchCriteria} personSearchCriteria
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonNewApiInterface
   */
  staffPersonsNewDashboardPost(
    personSearchCriteria: PersonSearchCriteria,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonDashboardDTO>;

  /**
   * Test new person dto
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonNewApiInterface
   */
  staffPersonsNewIdGet(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonWithRelationsDTO>;

  /**
   * Updates person
   * @param {PersonWithRelationsDTO} personWithRelationsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonNewApiInterface
   */
  staffPersonsNewPost(
    personWithRelationsDTO: PersonWithRelationsDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonWithRelationsDTO>;

  /**
   * Test new person dto
   * @param {PersonSearchCriteria} personSearchCriteria
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonNewApiInterface
   */
  staffPersonsNewSearchPost(
    personSearchCriteria: PersonSearchCriteria,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonWithRelationsDTO>;
}
